import { render, staticRenderFns } from "./ClickAndCollect.vue?vue&type=template&id=549e9c93"
import script from "./ClickAndCollect.vue?vue&type=script&lang=ts"
export * from "./ClickAndCollect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports